/**
 * This script is used to set the tracking consent for Shopify Customer Privacy.
 * @link https://shopify.dev/docs/api/consent-tracking
 */

document.addEventListener('DOMContentLoaded', (event) => {
  // Create the ElevarDataLayer if it doesn't exist
  window.dataLayer = window.dataLayer ?? [];
  window.ElevarDataLayer = window.ElevarDataLayer ?? [];

  // Enable logs
  ENABLE_LOGS = false;

  // Load the Shopify Customer Privacy JavaScript library.
  Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    (error) => {
      if (error) throw error;

      // In case the cookiebot is already accepted
      handleShopifyTrackingConsent();

      // Set tracking on Cookiebot consent event
      window.addEventListener('CookiebotOnConsentReady', function () {
        handleShopifyTrackingConsent();
      });
    }
  );

  function handleShopifyTrackingConsent() {
    if (!('Cookiebot' in window) || !('Shopify' in window) || !('customerPrivacy' in Shopify)) {
      return;
    }
    Shopify.customerPrivacy.setTrackingConsent(
      {
        analytics: Cookiebot.consent.statistics ? true : false,
        marketing: Cookiebot.consent.marketing ? true : false,
        preferences: Cookiebot.consent.preferences ? true : false,
      },
      () => {
        ENABLE_LOGS &&
          console.log('Shopify consent updated', Shopify.customerPrivacy.currentVisitorConsent());
      }
    );
  }
});
